module.exports = __webpack_public_path__ + "static/logo_sw-34b23a83378de3c0a14a7857bee95862.png";